
import casino_json from "../_asset/media/list_casino.json"

import e1 from "../_asset/girl/girl (21).png"
import e2 from "../_asset/girl/girl (23).png"
import mg from "../_asset/girl/girl (2).png"
import pp from "../_asset/girl/girl (3).png"
import ag from "../_asset/girl/girl (4).png"
import dg from "../_asset/girl/girl (5).png"
import wm from "../_asset/girl/girl (6).png"
import vv from "../_asset/girl/girl (7).png"
import mojos_img from "../_asset/girl/girl (8).png"
import absolutegames_img from "../_asset/girl/girl (9).png"
import onetouch_live_img from "../_asset/girl/girl (10).png"
import skywind_img from "../_asset/girl/girl (11).png"
import betgamestv_img from "../_asset/girl/girl (12).png"
import ezugi_img from "../_asset/girl/girl (13).png"
import bota_img from "../_asset/girl/girl (14).png"
import sexybcrt from "../_asset/girl/girl (15).png"
import PlayTech from "../_asset/girl/girl (16).png"
import MicroGamingGrand from "../_asset/girl/girl (17).png"

// import e1_logo from "../_asset/game logo/evolution1.png"
import e1_logo from "../_asset/game logo/evolution.png"
import e2_logo from "../_asset/game logo/evolution2.png"
import mg_logo from "../_asset/game logo/microgaming.png"
import pp_logo from "../_asset/game logo/PragmaticPlayLive.png"
import ag_logo from "../_asset/game logo/AsiaGaming.png"
import dg_logo from "../_asset/game logo/DreamGame.png"
import wm_logo from "../_asset/game logo/WMLive.png"
import vv_logo from "../_asset/game logo/vivo.png"
import bt_logo from "../_asset/game logo/bota.png"
import betgametv_logo from "../_asset/game logo/Betgamestv.png"
import skywind_logo from "../_asset/game logo/SkywindLive.png"
import ezugi_logo from "../_asset/game logo/ezugi.png"
import mojos_logo from "../_asset/game logo/7mojos.png"
import absolute_logo from "../_asset/game logo/absolute.png"
import onetouch_logo from "../_asset/game logo/onetouch.png"
import sexybcrt_logo from "../_asset/game logo/sexybcrt.png"
import PlayTech_logo from "../_asset/game logo/playtechlogo1.png"
import mggrand_logo from "../_asset/game logo/MGGRANDLOGO.png"

export type GameCompanyListType = 'evolution' | 'PragmaticPlay Live' | 'MicroGaming Plus' | 'Asia Gaming'
    | 'DreamGame' | 'WM Live' | 'vivo'
    | '7-mojos'
    | 'absolute'
    | 'onetouch'
    | 'Skywind Live'
    | 'Betgames.tv'
    | 'ezugi'
    | 'bota'
    | 'sexybcrt'
    | 'PlayTech'
    | 'MicroGaming'
export interface CasinoImageInterface {
    id: string,
    name: string,
    vendor: GameCompanyListType,
    img: string,
    logo: string,
}
export const compL = {
    "evolution": {
        img: e1,
        logo: e1_logo
    },
    // "evolution I": {
    //     img: e2,
    //     logo: e2_logo
    // },
    "PragmaticPlay Live": {
        img: pp,
        logo: pp_logo
    },
    "MicroGaming Plus": {
        img: mg,
        logo: mg_logo
    },
    "Asia Gaming": {
        img: ag,
        logo: ag_logo
    },
    'DreamGame': {
        img: dg,
        logo: dg_logo
    },
    'WM Live': {
        img: wm,
        logo: wm_logo
    },
    'vivo': {
        img: vv,
        logo: vv_logo
    },
    '7-mojos': {
        img: mojos_img,
        logo: mojos_logo
    },
    'absolute': {
        img: absolutegames_img,
        logo: absolute_logo

    },
    'Skywind Live': {
        img: skywind_img,
        logo: skywind_logo
    },
    'Betgames.tv': {
        img: betgamestv_img,
        logo: betgametv_logo
    },
    'ezugi': {
        img: ezugi_img,
        logo: ezugi_logo
    },
    'bota': {
        img: bota_img,
        logo: bt_logo
    },
    'onetouch': {
        img: onetouch_live_img,
        logo: onetouch_logo
    },
    'sexybcrt': {
        img: sexybcrt,
        logo: sexybcrt_logo
    },
    'PlayTech': {
        img: PlayTech,
        logo: PlayTech_logo
    },
    'MicroGaming': {
        img: MicroGamingGrand,
        logo: mggrand_logo
    },
}
const newJson = []
for (let comp of casino_json) {
    //@ts-ignore
    const vendorImageInfo = compL[comp.vendor as GameCompanyListType]
    if (vendorImageInfo) {
        const vendorObj: CasinoImageInterface = {
            id: comp.id,
            name: comp.title,
            vendor: comp.vendor as GameCompanyListType,
            img: vendorImageInfo?.img || "",
            logo: vendorImageInfo?.logo || ""
        }
        newJson.push(vendorObj)
    }
}
export const exportNewCasinoJson = newJson

// 아너링크 제외
export const otherCasino = ['Betgames.tv',
    'Skywind Live',
    '7-mojos',
    'absolute',
    'sexybcrt',
    'onetouch',]